import Theme from "./Theme";
export * from "./Theme";
export default Theme;
